import { InfoHeaderModule } from './../../../widgets/info-header/info-header.module';
import { ConfirmationPopUpModule } from './../../../widgets/confirmation-pop-up/confirmation-pop-up.module';
import { NewPostPopupModule } from './../../home/new-post-popup/new-post-popup.module';
import { DxButtonModule, DxLoadPanelModule, DxPopupModule, DxScrollViewModule } from 'devextreme-angular';
import { PostCardModule } from './../../home/post-card/post-card.module';
import { FeedComponent } from './feed.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FeedRoutingModule } from './feed-routing.module';


@NgModule({
  declarations: [FeedComponent],
  imports: [
		CommonModule,
		PostCardModule,
		FeedRoutingModule,
		NewPostPopupModule,
		ConfirmationPopUpModule,
		InfoHeaderModule,
		DxButtonModule,
		DxLoadPanelModule,
		DxPopupModule,
		DxScrollViewModule,
  ]
})
export class FeedModule { }
